<template >
  
  
      <div id="app" v-if="logged==true">
        <div class="main-wrapper">
          <Menu/>
          <div class="page-wrapper">
            <Navbar/>
            <router-view></router-view>
          </div>
        </div>
      <!--  <df-messenger
          intent="WELCOME"
          chat-title="MiFoodservice"
          agent-id="7ad439dc-9cb1-4455-a5c5-a856d27dd15b"
          language-code="es"
        ></df-messenger>-->
      </div>

      <div v-else>
          <router-view></router-view>
      </div>
   


</template>


<script>


import axios from 'axios';

import Menu from './components/Menu/Menu.vue'
import Navbar from './components/Navbar/Navbar.vue'
import $ from 'jquery'
import firebase from "firebase/app";
 import "firebase/database";
 import Swal from 'sweetalert2';
const firebaseConfig = {
    // Produccion
    apiKey: "AIzaSyBLyOhPH9YaePUSi5fIMjaavlrQVJ2-UnY",
    authDomain: "cantina-89c6a.firebaseapp.com",
    databaseURL: "https://helados-fs.firebaseio.com",
    projectId: "cantina-89c6a",
    storageBucket: "cantina-89c6a.appspot.com",
    messagingSenderId: "353062217145",
    appId: "1:353062217145:web:8849a49a1ec52077"

};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);


const userData = JSON.parse(sessionStorage.getItem('userData'));
let plataforma = "Helados";


export default {
    name: 'app',
    components:{
       
          Menu,
          Navbar,

          
  },
    data: () => ({
      logged: false,
    }),
    methods: {
          isLector(modulo){
            
                if (JSON.parse(sessionStorage.getItem('userPermisos')).find( record => record.ModulosAccess === modulo)) {
                  var status =  JSON.parse(sessionStorage.getItem('userPermisos')).find( record => record.ModulosAccess === modulo).Lector;
                  // console.log(modulo+' : '+status)
                  return status;
                }else{
                  console.log(modulo+' : '+false)
                  return false;
                }
            },
      isLogged() {

        userData
          ? this.logged = true
          : this.logged = false

          if (this.logged) {
            sessionStorage.clear();
            this.$router.push({ path: '/' })



                            axios
                        .get('https://auth.foodservice.com.ar/?type=login&user='+userData.leg_numdoc+'&access_token=1234567')
                        .then(response => {
                            console.log("ok")
                               sessionStorage.setItem('userPermisos', JSON.stringify(response.data[0].Permisos))
                             sessionStorage.setItem('userData', JSON.stringify(response.data[0].datos))
                             sessionStorage.setItem('userId', response.data[0].id)
                              const uId = sessionStorage.getItem('userId');

                            if (this.isLector(plataforma)==false) {
                              Swal.fire('Acceso denegado', 'No tienes los permisos necesarios para acceder a Genesis','error');
                              sessionStorage.clear();
                              location.reload();
                            }
                            
                             var correop = "";
                             var oculto ="";
                            
                             if (response.data[0].Email_de_recupero[0].correo!=null) {
                                correop = response.data[0].Email_de_recupero[0].correo;
                                oculto ="style='display:none;'";
                             }

                             console.log(response.data[0].Password[0].contrasena)

                             if (response.data[0].Password[0].contrasena==null) {

                                     (async function(){

                                           await Swal.fire({
                                            title: 'Ingrese una nueva contraseña',
                                            html:
                                            '<form action="#" id="searchForm">'+
                                              '<input required type="email" id="correo1" class="swal2-input" placeholder="Email de recupero" value="'+correop+'" '+oculto+' autocomplete="off"><span style="color:red;font-size:14px;display:none;" id="errormail">Email no coincide</span><input autocomplete="off" required type="email" id="correo2" class="swal2-input" placeholder="Repita Email de recupero" value="'+correop+'" '+oculto+'><input autocomplete="off" required type="password" id="pass1" class="swal2-input" placeholder="Nueva contraseña"  ><span style="color:red;font-size:14px;display:none;" id="errorpass">Password no coincide</span><input autocomplete="off" required type="password" id="pass2" class="swal2-input" placeholder="Repita Nueva contraseña"><button type="button" id="guardar" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block;">Guardar</button></form>',
                                               showCancelButton: false,   
                                               showConfirmButton: false, 
                                                didOpen(){
                                                  window.$("#guardar").click(function(){
                                                     

                                                    if(window.$("#correo1").val()=="") {
                                                      console.log("vacio")
                                                    }else if(window.$("#correo2").val()=="") {
                                                      console.log("vacio")
                                                    }else if(window.$("#pass1").val()=="") {
                                                      console.log("vacio")
                                                    }else if(window.$("#pass2").val()=="") {
                                                      console.log("vacio")
                                                    }else{

                                                      var correo1 = window.$("#correo1").val();
                                                      var correo2 = window.$("#correo2").val();

                                                      var pass1 = window.$("#pass1").val();
                                                      var pass2 = window.$("#pass2").val();

                                                      if (correo1!=correo2) {
                                                        window.$("#errormail").slideDown();
                                                      }else if(pass1!=pass2){
                                                        window.$("#errorpass").slideDown();
                                                      }else{
                                                        
                                                       

                                                        window.$("#errorpass").hide();
                                                        window.$("#errormail").hide();
                                                       

                                                        if (correop==null) {



                                                            firebase.database().ref('password/' + uId +'').update({
                                                              contrasena:pass1

                                                            })
                                                            .then(()=>{




                                                         firebase.database().ref('Email_de_recupero/' + uId +'').update({
                                                                                  correo:correo1

                                                                                })
                                                                                .then(()=>{
                                                                                  Swal.close();
                                                                                  Swal.fire('Datos Guardados', 'Felicitaciones!, ya puedes utilizar '+plataforma,'success');
                                                                                })
                                                                                .catch(e => {
                                                                                  console.log(e);
                                                                                });


                                                             
                                                            })
                                                            .catch(e => {
                                                              console.log(e);
                                                            });

                                                         

                                                        }else{

                                                           firebase.database().ref('password/' + uId +'').update({
                                                              contrasena:pass1

                                                            })
                                                            .then(()=>{


                                                              Swal.close();
                                                                                  Swal.fire('Datos Guardados', 'Felicitaciones!, ya puedes utilizar '+plataforma,'success');


                                                             
                                                            })
                                                            .catch(e => {
                                                              console.log(e);
                                                            });


                                                        }

                                                   



                                                      


                                                      }

                                                        if (correo1==correo2) {
                                                          window.$("#errormail").hide();
                                                        }

                                                        if(pass1==pass2){
                                                          window.$("#errorpass").hide();
                                                        }


                                                    }

                                                    
                                                  })
                                               }
                                           


                                            })

                                    })();



                             }
                          
                               
                            })
                        .catch(error => {console.log(error);});


           setTimeout(function(){
            $("#correo1").val("");
            $("#pass1").val("");
           },1000)


           


          }else{
            this.$router.push('/Login')
          }
      },
      logout() {
        sessionStorage.removeItem('userData')
       

        this.$router.push('/login')
      },
     
    },
    computed: {
      loggedUser() {
        const token = sessionStorage.getItem('userData')
        const payload = JSON.parse(atob(token.split('.')[1]))
        console.log(payload)
        return payload
      }
    },
    mounted() {
      this.isLogged()

    }
  };



</script>

